module.exports = __webpack_public_path__ + "img/zoomin.c239e3c4.svg";